import type { FaireProductEntity } from "../../entity_types/product";

export const p_ba9yrq92rv: FaireProductEntity = {
  token: "p_ba9yrq92rv",
  type: "product",
  name: "Liam Bermuda Shorts (2S-2M-2L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/c61efab74d224bb05fe175833d92cc203c37a334b7cf7d8b0c540a000fdf6b94.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c77cc2d6e1d2c59fcf88972dc1234deb9aba5f237a5a32d0daa4b381b184ae00.jpeg",
    "https://cdn.faire.com/fastly/1a7f4532643818bba44bc3bb758b5013f35a37ee2b7c663a2e17e3eb072a9748.jpeg",
    "https://cdn.faire.com/fastly/df60044d880fae812be527385297330b5792d1cda9e61b060f28d8d2b56ca55f.jpeg",
    "https://cdn.faire.com/fastly/1026813c3d61beb365a54c4cea0d8af44ca3228020ca9850095e501b977185f6.jpeg",
    "https://cdn.faire.com/fastly/e5cd0945d777f17f9cb057fe77baa8dc8178ce98b66e95030904c19e7fada15a.jpeg",
    "https://cdn.faire.com/fastly/c72b79e7b439acbe25cbcd25ce4824c80075582c97ec0b562b445bc9eb9965ff.jpeg",
    "https://cdn.faire.com/fastly/f607b9bac55436c6188e73144f87729c561d0178fa0589062d1842e16119fd8d.jpeg",
    "https://cdn.faire.com/fastly/ef5a52bc42449d91d6bd539cb78ad7f28c248615ba425319ee2f09a1718a57e5.jpeg",
    "https://cdn.faire.com/fastly/3701f2f6387a8de1e75e79bd0cbde764105a5c382359c80aa207a1f5b3fc93c7.jpeg",
    "https://cdn.faire.com/fastly/7890d570d957a570b55675a5b901fafb033847c42f63ddbd47d61c207f78e94d.jpeg",
    "https://cdn.faire.com/fastly/b60542390df3f6e56cfaef2da307138dc0766b35653a9d2fead9dd1f3b7588a8.jpeg",
  ],
  priceDollars: 324,
  description:
    '𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nThe Liam Shorts offer a modern twist on the classic Bermuda. They feature an elasticated waistband for comfort, side seam pockets, and a relaxed fit with slightly flared panels for added shape. The elongated inseam and subtle A-line silhouette make them easy to wear from day to night.\n\n𝐏𝐥𝐞𝐚𝐬𝐞 𝐧𝐨𝐭𝐞:\n\nColors - The washing process gives each garment unique character. Please allow for slight color and fit variation for each garment as is the beauty of garment wash. Pieces with the same color name may not match exactly.\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n100% Cotton\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Washing these garments only with like colors and in cold water\n• Recommend to Hang Dry for the best result!\n\n𝐀𝐩𝐩𝐫𝐨𝐱𝐢𝐦𝐚𝐭𝐞 𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\n\nSmall: Waist 12"(relaxed/flat), Hip 22", Inseam 12", Leg opening 13"\n\nMedium: Waist 13"(relaxed/flat), Hip 23", Inseam 12 1/4", Leg opening 13 1/2"\n\nLarge: Waist 14"(relaxed/flat), Hip 24", Inseam 12 1/2", Leg opening 14"\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size small\n\nMade in South Korea\n\nMSRP: $110 USD',
  tags: [],
  msrpDollars: 660,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:07.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
